<template>
  <main class="olimpiadas-page" v-if="contest">
    <!-- Top nav: logo, tabs, Ingresa / Regístrate -->
    <header class="landing-nav">
      <div class="landing-nav__inner">
        <MobiusLogo />
        <nav class="landing-nav__tabs">
          <a href="#inicio" class="landing-nav__tab">Inicio</a>
          <a href="#olimpiada" class="landing-nav__tab">Olimpiada</a>
          <a href="#why-mobius" class="landing-nav__tab">Por qué Mobius</a>
          <a href="#aplicaciones" class="landing-nav__tab">Aplicaciones matemáticas</a>
          <a href="#contacto" class="landing-nav__tab">Contacto</a>
        </nav>
        <div class="landing-nav__actions">
          <router-link to="/v2/auth/login" class="landing-nav__link">Ingresa</router-link>
          <router-link to="/v2/auth/register" class="landing-nav__cta">Regístrate</router-link>
        </div>
      </div>
    </header>

    <!-- Inicio: landing intro -->
    <section id="inicio" class="landing-inicio">
      <div class="landing-inicio__inner">
        <h2 class="landing-inicio__title">Aprende más, estudia menos</h2>
        <p class="landing-inicio__text">
          Mobius utiliza técnicas de Machine Learning e Inteligencia Artificial
          para optimizar tu aprendizaje, dentro y fuera del aula, haciendo
          que cada minuto de estudio cuente.
        </p>
        <div class="landing-inicio__ctas">
          <a href="#olimpiada" class="cta-primary">Olimpiadas 2026</a>
          <router-link to="/explore" class="landing-inicio__secondary">Explorar cursos</router-link>
        </div>
      </div>
    </section>

    <!-- Olimpiada: hero + inscripción -->
    <section id="olimpiada" class="olimpiadas-hero">
      <div class="olimpiadas-hero__content">
        <div class="olimpiadas-hero__badge">Edición 2026</div>
        <h1>Olimpiadas Mobius <span class="olimpiadas-hero__accent">2026</span></h1>
        <p class="olimpiadas-hero__lead">
          Una competencia internacional para jóvenes que disfrutan pensar,
          resolver y retarse.
        </p>
        <ul class="olimpiadas-hero__bullets">
          <li>Inscripción gratuita: Febrero – Abril</li>
          <li>Clasificatoria Online: 3 de Mayo 2026</li>
          <li>Gran Final Online: 24 de Mayo 2026</li>
        </ul>
        <div class="registration-inline__form">
        <label class="terms-checkbox">
          <input type="checkbox" v-model="termsAccepted" />
          <span>
            He leído y acepto los términos y condiciones de las Olimpiadas Mobius
            2026
          </span>
        </label>
        <button class="terms-link" type="button" @click="showTermsModal = true">
          Ver términos y condiciones
        </button>
        <button class="terms-link terms-link--block" type="button" @click="showFaqModal = true">
          Ver reglas y preguntas frecuentes
        </button>
        <p v-if="termsError" class="terms-error">
          Debes aceptar los términos para continuar.
        </p>
        <button class="cta-primary" @click="handleRegister">
          Inscríbete y empieza a entrenar
        </button>
        <div class="landing-contact-ctas mt-4">
          <a href="https://wa.me/573053583323" target="_blank" rel="noopener noreferrer" class="landing-contact-cta landing-contact-cta--wa">WhatsApp</a>
          <a href="https://instagram.com/mobiusml" target="_blank" rel="noopener noreferrer" class="landing-contact-cta landing-contact-cta--ig">Instagram</a>
          <span class="landing-contact-email">administrador@mobiusml.com</span>
        </div>
      </div>
      </div>
      <div class="olimpiadas-hero__visual prizes-animated">
  <div class="prizes-header">
    <span class="prizes-trophy">🏆</span>
    <span class="prizes-title">¡Grandes Premios 2026!</span>
  </div>

  <!-- Podium -->
  <div class="podium">
    <div class="podium-place silver">
      <span class="medal">🥈</span>
      <strong>USD 200</strong>
      <small>2<sup>o</sup> lugar</small>
    </div>

    <div class="podium-place gold">
      <span class="medal shine">🥇</span>
      <strong>USD 400</strong>
      <small>1<sup>er</sup> lugar</small>
    </div>

    <div class="podium-place bronze">
      <span class="medal">🥉</span>
      <strong>USD 100</strong>
      <small>3<sup>er</sup> lugar</small>
    </div>
  </div>

  <!-- Bonus -->
  <div class="prizes-bonus shine-bonus">
    <span class="bonus-icon">🎓</span>
    <span>
      <strong>USD 3000 en membresías Mobius gratuitas</strong> para estudiantes de los colegios de los tres primeros lugares.
    </span>
  </div>
</div>

    </section>

    <section class="trust-bar">
      <div class="trust-item">🌍 Participación internacional</div>
      <div class="trust-item">📜 Certificado</div>
      <div class="trust-item">🏆 Premios</div>
      <div class="trust-item">💻 Online</div>
    </section>

    <!-- Por qué Mobius -->
    <section id="why-mobius" class="landing-why">
      <div class="landing-why__inner">
        <h2 class="landing-why__title">¿Por qué Mobius?</h2>
        <div class="landing-why__grid">
          <div class="landing-why__card">
            <h3>Seguimiento en tiempo real</h3>
            <p>Mobius provee al estudiante un reporte de desempeño personalizado que identifica sus fortalezas y prioriza los temas que debe mejorar.</p>
          </div>
          <div class="landing-why__card">
            <h3>Inteligencia educativa</h3>
            <p>Profesores y directivos acceden a reportes de desempeño individuales y grupales que ayudan a optimizar el proceso de enseñanza–aprendizaje.</p>
          </div>
          <div class="landing-why__card">
            <h3>Microlecciones</h3>
            <p>Mobius usa microlecciones que permiten a los estudiantes aprender conceptos clave en minutos y reforzarlos con práctica inmediata para consolidar su aprendizaje.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Aplicaciones matemáticas (same as landing: infinite bar + text) -->
    <section id="aplicaciones" class="landing-apps">
      <div class="landing-apps__grid">
        <div class="landing-apps__inner">
          <h2 class="landing-apps__title">Aplicaciones Matemáticas</h2>
          <p class="landing-apps__text">
            Descubre cómo las matemáticas se usan en tecnología, finanzas y negocios con expertos de la industria.
          </p>
          <router-link to="/infographic" class="cta-primary">Ver curso</router-link>
        </div>
        <div class="apps-logos">
          <infinite-slide-bar>
            <div class="items flex">
              <img src="/src/assets/logos/amazon.svg" alt="amazon" class="w-16 h-10 object-contain" />
              <img src="/src/assets/logos/apple.svg" alt="apple" class="w-16 h-10 object-contain" />
              <img src="/src/assets/logos/google.svg" alt="google" class="w-16 h-10 object-contain" />
              <img src="/src/assets/logos/meta.svg" alt="meta" class="w-16 h-10 object-contain" />
              <img src="/src/assets/logos/microsoft.svg" alt="microsoft" class="w-16 h-10 object-contain" />
              <img src="/src/assets/logos/tesla.svg" alt="tesla" class="w-16 h-10 object-contain" />
            </div>
          </infinite-slide-bar>
        </div>
      </div>
    </section>

    <!-- Contacto -->
    <section id="contacto" class="landing-contact">
      <div class="landing-contact__inner">
        <h2 class="landing-contact__title">Contacto</h2>
        <p class="landing-contact__text">
          Contáctanos: <a href="mailto:administrador@mobiusml.com" class="landing-contact__email">administrador@mobiusml.com</a>
        </p>
      </div>
    </section>

    <OlimpiadasFaqModal :open="showFaqModal" @close="showFaqModal = false" />

    <OlimpiadasProfileFormModal
      :open="showProfileFormModal"
      @close="showProfileFormModal = false"
      @success="onProfileFormSuccess"
    />
    <OlimpiadasRegistrationModal
      :open="showSuccessModal"
      @close="onSuccessModalClose"
    />
    <OlimpiadasTermsModal
      :open="showTermsModal"
      @close="showTermsModal = false"
    />

    <!-- Auth required: show message + options instead of redirecting straight to login -->
    <div
      v-if="showAuthRequiredModal"
      class="auth-required-overlay"
      @click.self="showAuthRequiredModal = false"
    >
      <div class="auth-required-modal">
        <p class="auth-required-message">
          Necesitas crear una cuenta o iniciar sesión para continuar.
        </p>
        <div class="auth-required-actions">
          <router-link
            :to="{ path: '/v2/auth/register', query: { redirect: $route.fullPath } }"
            class="mob-btn mob-cta-gold auth-required-btn"
          >
            Crear cuenta
          </router-link>
          <router-link
            :to="{ path: '/v2/auth/login', query: { redirect: $route.fullPath } }"
            class="mob-btn mob-cta-gold-outline auth-required-btn"
          >
            Iniciar sesión
          </router-link>
        </div>
        <button
          type="button"
          class="auth-required-close"
          @click="showAuthRequiredModal = false"
          aria-label="Cerrar"
        >
          ×
        </button>
      </div>
    </div>
  </main>
</template>

<script>
import { contests } from "./contestData";
import MobiusLogo from "@/components/MobiusLogo.vue";
import OlimpiadasProfileFormModal from "./OlimpiadasProfileFormModal.vue";
import OlimpiadasRegistrationModal from "./OlimpiadasRegistrationModal.vue";
import OlimpiadasTermsModal from "./OlimpiadasTermsModal.vue";
import OlimpiadasFaqModal from "./OlimpiadasFaqModal.vue";
import InfiniteSlideBar from "vue-infinite-slide-bar";
import {
  loadRegistrationIntent,
  runRegistrationFlow,
  buildRegistrationIntent,
  saveRegistrationIntent,
} from "./registrationFlow";

export default {
  name: "ContestsListOlimpiadas2",
  components: {
    MobiusLogo,
    OlimpiadasProfileFormModal,
    OlimpiadasRegistrationModal,
    OlimpiadasTermsModal,
    OlimpiadasFaqModal,
    InfiniteSlideBar,
  },
  data() {
    return {
      contest: contests[0],
      showProfileFormModal: false,
      showSuccessModal: false,
      showTermsModal: false,
      showFaqModal: false,
      showAuthRequiredModal: false,
      termsAccepted: false,
      termsError: false,
    };
  },
  mounted() {
    this.resumeRegistrationIfNeeded();
    document.documentElement.style.scrollBehavior = "smooth";
  },
  beforeUnmount() {
    document.documentElement.style.scrollBehavior = "";
  },
  methods: {
    handleRegister() {
      if (!this.termsAccepted) {
        this.termsError = true;
        return;
      }
      window.localStorage.setItem("olimpiadas_terms_accepted", "true");
      this.termsError = false;

      const isAuthenticated = this.$store.state.auth.isAuthenticated;
      if (!isAuthenticated) {
        const intent = buildRegistrationIntent({
          contest: this.contest,
          sourcePath: this.$route.fullPath,
        });
        saveRegistrationIntent(intent);
        this.showAuthRequiredModal = true;
        return;
      }

      runRegistrationFlow({
        contest: this.contest,
        router: this.$router,
        onNeedsProfile: () => {
          this.showProfileFormModal = true;
        },
        onRegistered: () => {
          this.showSuccessModal = true;
        },
        onError: () => {
          this.$toasted.error("No pudimos completar la inscripción.", {
            position: "top-center",
            duration: 3000,
          });
        },
      });
    },
    resumeRegistrationIfNeeded() {
      const intent = loadRegistrationIntent();
      if (!intent || !this.contest) return;
      if (intent.slug !== this.contest.slug) return;
      if (window.localStorage.getItem("olimpiadas_terms_accepted") === "true") {
        this.termsAccepted = true;
        this.termsError = false;
      }
      this.handleRegister();
    },
    onProfileFormSuccess() {
      this.showProfileFormModal = false;
      this.showSuccessModal = true;
    },
    onSuccessModalClose() {
      this.showSuccessModal = false;
      this.$router.push("/dashboard");
    },
  },
};
</script>

<style scoped>
.olimpiadas-page {
  min-height: 100vh;
  padding: 0 0 80px;
  background: #faf8f5;
  color: #1a1a1a;
  scroll-behavior: smooth;
  overflow-x: hidden;
  box-sizing: border-box;
}
.olimpiadas-page *,
.olimpiadas-page *::before,
.olimpiadas-page *::after {
  box-sizing: border-box;
}

/* Top nav – subtle cream, warm accent */
.landing-nav {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(250, 248, 245, 0.97);
  border-bottom: 1px solid rgba(180, 100, 60, 0.12);
  backdrop-filter: blur(8px);
}

.landing-nav__inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 14px 5vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
}
@media (max-width: 640px) {
  .landing-nav__inner {
    padding: 12px 16px;
    gap: 12px;
  }
}

.landing-nav__logo {
  display: flex;
  align-items: center;
}

.landing-nav__logo img {
  height: 36px;
  width: auto;
}

.landing-nav__tabs {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.landing-nav__tab {
  padding: 8px 14px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 500;
  color: #3d3d3d;
  text-decoration: none;
  background: rgba(180, 100, 60, 0.06);
  transition: background 0.2s, color 0.2s;
}

.landing-nav__tab:hover {
  background: rgba(180, 100, 60, 0.12);
  color: #1a1a1a;
}

.landing-nav__actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.landing-nav__link {
  font-size: 14px;
  font-weight: 600;
  color: #3d3d3d;
  text-decoration: none;
}

.landing-nav__link:hover {
  color: #1a1a1a;
}

.landing-nav__cta {
  padding: 10px 20px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  text-decoration: none;
  background: #b85426;
  transition: background 0.2s, box-shadow 0.2s;
}

.landing-nav__cta:hover {
  background: #c45c2a;
  box-shadow: 0 2px 12px rgba(180, 84, 38, 0.35);
}

/* Inicio section */
.landing-inicio {
  padding: 56px 5vw 48px;
  max-width: 1200px;
  margin: 0 auto;
  scroll-margin-top: 72px;
}
@media (max-width: 480px) {
  .landing-inicio {
    padding: 32px 16px 40px;
  }
}

#olimpiada {
  scroll-margin-top: 72px;
}

#why-mobius {
  scroll-margin-top: 72px;
}

#aplicaciones {
  scroll-margin-top: 72px;
}

#contacto {
  scroll-margin-top: 72px;
}


.landing-inicio__inner {
  max-width: 640px;
}

.landing-inicio__title {
  font-size: clamp(28px, 4vw, 36px);
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 16px 0;
  line-height: 1.2;
}

.landing-inicio__text {
  font-size: 17px;
  color: #4a4a4a;
  line-height: 1.55;
  margin: 0 0 24px 0;
}

.landing-inicio__ctas {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  align-items: center;
}

.landing-inicio__secondary {
  padding: 12px 20px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  color: #b85426;
  text-decoration: none;
  border: 1px solid rgba(180, 84, 38, 0.4);
  background: transparent;
}

.landing-inicio__secondary:hover {
  background: rgba(180, 84, 38, 0.08);
  color: #9a4520;
}

/* Why Mobius */
.landing-why {
  padding: 48px 5vw 56px;
  max-width: 1200px;
  margin: 0 auto;
}

.landing-why__title {
  font-size: clamp(24px, 3vw, 30px);
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 32px 0;
  text-align: center;
}

.landing-why__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 24px;
}

.landing-why__card {
  background: #fff;
  border: 1px solid rgba(180, 100, 60, 0.12);
  border-radius: 16px;
  padding: 24px;
  text-align: center;
}

.landing-why__card h3 {
  font-size: 17px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 12px 0;
}

.landing-why__card p {
  font-size: 14px;
  color: #4a4a4a;
  line-height: 1.5;
  margin: 0;
}

.landing-apps {
  padding: 48px 5vw 56px;
  max-width: 1200px;
  margin: 0 auto;
}

.landing-apps__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  align-items: center;
}

@media (max-width: 768px) {
  .landing-apps__grid {
    grid-template-columns: 1fr;
  }
  .landing-apps__bar {
    order: -1;
  }
}

.landing-apps__inner {
  max-width: 560px;
}

/* Same as landing home: infinite moving bar */
.landing-apps .apps-logos {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  min-width: 0;
}

.landing-apps .apps-logos .items {
  display: flex;
  align-items: center;
  gap: 36px;
}

.landing-apps .apps-logos .w-16 {
  width: 4rem;
}

.landing-apps .apps-logos .h-10 {
  height: 2.5rem;
}

.landing-apps .apps-logos .object-contain {
  object-fit: contain;
}

.landing-apps__title {
  font-size: clamp(24px, 3vw, 28px);
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 12px 0;
}

.landing-apps__text {
  font-size: 16px;
  color: #4a4a4a;
  line-height: 1.5;
  margin: 0 0 20px 0;
}

.landing-contact {
  padding: 40px 5vw 56px;
  max-width: 1200px;
  margin: 0 auto;
  border-top: 1px solid rgba(180, 100, 60, 0.12);
}

.landing-contact__inner {
  text-align: center;
}

.landing-contact__title {
  font-size: clamp(22px, 2.5vw, 26px);
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 12px 0;
}

.landing-contact__text {
  font-size: 16px;
  color: #4a4a4a;
  margin: 0;
}

.landing-contact__email {
  color: #b85426;
  font-weight: 600;
  text-decoration: none;
}

.landing-contact__email:hover {
  text-decoration: underline;
}

.terms-link--block {
  display: block;
  margin-top: 4px;
}

.olimpiadas-hero {
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: 72vh;
  margin-bottom: 0;
  background: transparent;
  border-radius: 0;
  padding: 48px 5vw 56px;
  max-width: 100%;
  gap: 48px;
  align-items: center;
  min-width: 0;
}

@media (max-width: 900px) {
  .olimpiadas-hero {
    grid-template-columns: 1fr;
    min-height: auto;
    padding: 32px 20px 40px;
  }
}
@media (max-width: 480px) {
  .olimpiadas-hero {
    padding: 24px 16px 32px;
    gap: 28px;
  }
}

.olimpiadas-hero__content {
  max-width: 560px;
  min-width: 0;
  width: 100%;
  overflow-wrap: break-word;
}

.olimpiadas-hero__badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  background: rgba(180, 84, 38, 0.12);
  color: #9a4520;
  border: 1px solid rgba(180, 84, 38, 0.25);
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 16px;
}

.olimpiadas-hero h1 {
  font-size: clamp(28px, 4vw, 40px);
  font-weight: 700;
  margin-bottom: 14px;
  color: #1a1a1a;
  line-height: 1.2;
}

.olimpiadas-hero__accent {
  color: #b85426;
  font-weight: 700;
}

.olimpiadas-hero__lead {
  color: #4a4a4a;
  margin-bottom: 20px;
  font-size: 17px;
  line-height: 1.5;
}

.olimpiadas-hero p {
  color: #4a4a4a;
  margin-bottom: 16px;
  font-size: 16px;
}

.olimpiadas-hero__bullets {
  padding-left: 20px;
  color: #2d2d2d;
  margin-bottom: 24px;
}

.olimpiadas-hero__bullets li {
  margin-bottom: 8px;
}

.olimpiadas-hero__cta {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
}

.cta-primary {
  border: none;
  background: #b85426;
  color: #ffffff;
  font-weight: 700;
  padding: 14px 24px;
  border-radius: 12px;
  cursor: pointer;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, box-shadow 0.2s;
}

.cta-primary:hover {
  background: #c45c2a;
  box-shadow: 0 4px 14px rgba(180, 84, 38, 0.35);
}

.landing-contact-ctas {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.landing-contact-cta {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: opacity 0.2s, box-shadow 0.2s;
}
.landing-contact-cta:hover {
  opacity: 0.9;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.landing-contact-cta--wa {
  background: #25d366;
  color: #fff;
}
.landing-contact-cta--ig {
  background: linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc2a8d);
  color: #fff;
}
.landing-contact-email {
  color: #000;
  font-size: 14px;
  font-weight: 500;
  align-self: center;
}
.cta-primary--small {
  padding: 10px 16px;
  font-size: 14px;
}

.cta-secondary {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.cta-secondary__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 18px;
  border-radius: 12px;
  background: #656ec9;
  color: #ffffff;
  font-weight: 600;
  text-decoration: none;
}

.cta-secondary__note {
  font-size: 12px;
  color: #8b92a5;
}

.olimpiadas-hero__visual {
  display: grid;
  align-content: center;
  gap: 16px;
  background: #c45c2a;
  border-radius: 20px;
  padding: 28px;
  color: #1a1a1a;
  box-shadow: 0 16px 40px rgba(180, 84, 38, 0.25);
  min-width: 0;
  width: 100%;
}

@media (max-width: 900px) {
  .olimpiadas-hero__visual {
    min-height: 280px;
  }
}
@media (max-width: 480px) {
  .olimpiadas-hero__visual {
    padding: 20px 16px;
    gap: 12px;
  }
}

.olimpiadas-hero__visual .prizes-header {
  color: #1a1a1a;
}

.olimpiadas-hero__visual .prizes-title {
  font-weight: 700;
  color: #1a1a1a;
}

.olimpiadas-hero__visual .podium-place {
  background: rgba(255, 255, 255, 0.6);
  color: #1a1a1a;
}

.olimpiadas-hero__visual .podium-place strong,
.olimpiadas-hero__visual .podium-place small {
  color: #1a1a1a;
}

.olimpiadas-hero__visual .prizes-bonus {
  background: rgba(255, 255, 255, 0.55);
  color: #1a1a1a;
}

.hero-visual__badge {
  font-size: 12px;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.2);
  padding: 6px 12px;
  border-radius: 999px;
  width: fit-content;
}

.hero-visual__card {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  background: rgba(255, 255, 255, 0.18);
  padding: 16px;
  border-radius: 16px;
}

.hero-visual__icon {
  font-size: 22px;
  background: #ffffff;
  color: #1d2433;
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  border-radius: 12px;
}

.trust-bar {
  max-width: 100%;
  margin: 0;
  padding: 24px 5vw;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(200px, 100%), 1fr));
  gap: 16px;
  background: rgba(255, 252, 248, 0.9);
  border-top: 1px solid rgba(180, 100, 60, 0.1);
  border-bottom: 1px solid rgba(180, 100, 60, 0.1);
}
@media (max-width: 480px) {
  .trust-bar {
    padding: 20px 16px;
  }
}

.trust-item {
  font-size: 14px;
  color: #3d3d3d;
  font-weight: 600;
  text-align: center;
}

.registration-inline {
  max-width: 1200px;
  margin: 0 auto 48px;
  padding: 40px 5vw;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 32px;
  background: transparent;
}

.registration-inline__form {
  display: grid;
  gap: 12px;
  min-width: 0;
}

.terms-checkbox {
  display: flex;
  gap: 10px;
  min-width: 0;
  font-size: 14px;
  color: #1d2433;
}
.terms-checkbox span {
  overflow-wrap: break-word;
  word-break: break-word;
}

.terms-link {
  border: none;
  background: none;
  color: #b85426;
  font-weight: 600;
  text-align: left;
  padding: 0;
  cursor: pointer;
}

.terms-link:hover {
  color: #9a4520;
}

.registration-inline__form .terms-error {
  color: #dc2626 !important;
  font-size: 14px;
  font-weight: 600;
  margin: 4px 0 0 0;
}

/* Auth required modal */
.auth-required-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
}
.auth-required-modal {
  position: relative;
  background: #ffffff;
  border-radius: 16px;
  padding: 28px 24px;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}
.auth-required-message {
  font-size: 1.35rem;
  font-weight: 600;
  color: #1d2433;
  margin: 0 0 24px 0;
  line-height: 1.4;
}
.auth-required-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.auth-required-actions .auth-required-btn {
  text-align: center;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 48px;
  padding: 14px 24px;
  box-sizing: border-box;
}
.auth-required-close {
  position: absolute;
  top: 12px;
  right: 12px;
  border: none;
  background: none;
  font-size: 24px;
  line-height: 1;
  color: #8b92a5;
  cursor: pointer;
  padding: 4px;
}
.auth-required-close:hover {
  color: #1d2433;
}

.info-grid {
  max-width: 1120px;
  margin: 0 auto 32px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 20px;
}

.info-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 16px 30px rgba(23, 30, 52, 0.06);
}

.info-card h3 {
  margin-bottom: 12px;
}

.info-card ul {
  padding-left: 18px;
  color: #1d2433;
  margin-bottom: 16px;
}

.detail-block {
  max-width: 1120px;
  margin: 0 auto 32px;
  background: #ffffff;
  border-radius: 18px;
  padding: 28px;
  box-shadow: 0 16px 32px rgba(23, 30, 52, 0.08);
}

.detail-block__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 24px;
  margin-top: 16px;
}

.detail-block ul {
  padding-left: 18px;
  color: #1d2433;
}

.prizes-block {
  max-width: 1120px;
  margin: 0 auto 32px;
  background: #ffffff;
  border-radius: 18px;
  padding: 28px;
  box-shadow: 0 16px 32px rgba(23, 30, 52, 0.08);
}

.prizes-block ul {
  padding-left: 18px;
  margin-top: 12px;
}

.prep-block {
  max-width: 1120px;
  margin: 0 auto 32px;
  background: #ffffff;
  border-radius: 18px;
  padding: 28px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 16px 32px rgba(23, 30, 52, 0.08);
}

.faq-block {
  max-width: 1120px;
  margin: 0 auto 32px;
  background: #ffffff;
  border-radius: 18px;
  padding: 28px;
  box-shadow: 0 16px 32px rgba(23, 30, 52, 0.08);
}

.faq-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 20px;
  margin-top: 16px;
}

.olimpiadas-footer {
  max-width: 1120px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 12px;
  color: #8b92a5;
  font-size: 13px;
}

.footer-links {
  display: flex;
  gap: 16px;
}

.footer-links a {
  color: #5b6476;
  text-decoration: none;
}

/* FAQ: Preguntas frecuentes Mobius */
.olimpiadas-faq {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
}
.faq-title {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 16px 0;
}
.details-card {
  background: #fff;
  border-radius: 14px;
  padding: 20px 24px;
  border: 1px solid rgba(180, 100, 60, 0.12);
}
.details-card h3 {
  font-size: 17px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 12px 0;
}
.details-card h4 {
  font-size: 15px;
  font-weight: 600;
  color: #374151;
  margin: 16px 0 8px 0;
}
.details-card h4:first-of-type {
  margin-top: 0;
}
.details-card p {
  font-size: 14px;
  color: #4b5563;
  margin: 0 0 10px 0;
  line-height: 1.5;
}
.faq-lead {
  margin-bottom: 14px !important;
}
.details-card .bullets {
  list-style: disc;
  padding-left: 22px;
  margin: 0 0 12px 0;
  color: #4b5563;
  font-size: 14px;
  line-height: 1.55;
}
.details-card .bullets li {
  margin-bottom: 6px;
}
.details-card .cta-primary {
  margin-top: 12px;
}
@media (max-width: 640px) {
  .details-card {
    padding: 16px 18px;
  }
  .faq-title {
    font-size: 20px;
  }
}
</style>
